<template>
  <div class="px-3 px-lg-10 pt-5 pt-lg-10" style="margin-bottom: 30px" id="kt_content_container">
    <Loader :isLoading="!isReady && !getScrollContacts?.length">
      <div>
        <div class="post d-flex flex-column-fluid" id="kt_post">
          <div class="contactList">
            <ScrollableListContainer
                id="scrollable-list-container"
                :loading="!isReady"
                :length="getScrollContacts?.length"
                :empty-text="$t('reports.noData')"
                :current-page="getScrollContactsMeta.current_page"
                :last-page="getScrollContactsMeta.last_page"
                container-height="75vh"
                @load-next-page="loadNextContacts"
            >
              <template #empty>
                <div class="row text-center justify-content-center align-items-center"
                     style="height :60vh !important;width: 100%!important;">
                  <div class="text-center">
                    <div class="pt-8 d-flex justify-content-center">
                      <Img filename="empty.png" alt=""
                           class="mw-100 h-150px h-sm-225px" />
                    </div>
                    <h2 class="fs-2x fw-bolder mb-0">{{ $t('contacts.no_contact_found') }}</h2>
                    <p class="text-gray-400 fs-4 fw-bold py-7">{{ $t('button.clic') }}<br /></p>
                    <Button btn-class="text-center  btn-sm" v-if="$can('contact_create')" type="new" btn-text="contacts.new_contact" @click="openModalCreateContact"/>
                  </div>
                </div>
              </template>
              <template #default>
                <div class="row g-3 align-items-stretch">
                  <ContactCard  v-for="contact in getScrollContacts" :contact="contact"></ContactCard>
                </div>
              </template>
            </ScrollableListContainer>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>

<script setup>
import { computed, inject, nextTick, onMounted, ref, watch } from 'vue'
import {useStore} from "vuex";
import ContactCard from "@/components/contact/ContactCard.vue";
import Button from "@/components/Button.vue";
import Img from "@/components/Img.vue";
import Loader from "@/components/Loader.vue";
import ScrollableListContainer from "@/components/ScrollableListContainer.vue";

const props = defineProps({
  filter: {
    type: String,
    default: ''
  },
  type: {
    type: String,
    default: ''
  },
  search: {
    type: String,
    default: ''
  }
})

const emitter = inject('emitter')

const store = useStore()
const search = ref(props.search ?? '')
const $contacts = ref('')
const filter = ref(props.filter ?? 'all')
const contactType = ref(props.type ?? 'all')

const isReady = ref(false)



const getScrollContacts = computed(() => store.getters['contacts/getScrollContacts'])
const getScrollContactsMeta = computed(() => store.getters['contacts/getScrollContactsMeta'])


watch(() => props.filter, (value) => {
  filter.value = value ?? 'all'
})

watch(() => props.type, (value) => {
  contactType.value = value ?? 'all'
})

watch(() => props.search, (value) => {
  search.value = value
})

onMounted(async() => {

 loadCountries()
 loadCurrencies()
 loadScrollContacts({ search: search.value, filter: filter.value, type: contactType.value })

  emitter?.on('reload-contact-page', () => loadScrollContacts({ search: search.value, filter: filter.value, type: contactType.value }))
})

watch(() => [filter.value,contactType.value,search.value], (value) => {
  loadScrollContacts({ search: search.value, filter: filter.value, type: contactType.value })
})

const loadCountries = async () => {
 try {
   await store.dispatch('countries/loadCountries')
 }catch (e) {
 }
}

const loadCurrencies = async () => {
 try {
   await store.dispatch('company/loadCurrencies')
 }catch (e) {
 }
}

const loadScrollContacts = (data) => {
  isReady.value = false
  store.dispatch('contacts/loadScrollContacts', data)
      .then()
      .catch()
      .finally(() => isReady.value = true)
}

const loadNextContacts = (page) => loadScrollContacts({ search: search.value, filter: filter.value, type: contactType.value, page });

function openModalCreateContact() {
 $('#contactCreateModal').modal('toggle')
}



</script>

<style scoped>
#contenu {
 padding-right: 15px;
 height: calc(90vh - 240px) !important;
 overflow-y: scroll;
 overflow-x: hidden;
}

#contenu::-webkit-scrollbar-track {
 -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
 border-radius: 8px;
 background-color: #F5F5F5;
}

#contenu::-webkit-scrollbar {
 width: 10px;
 background-color: #F5F5F5;
}

#contenu::-webkit-scrollbar-thumb {
 border-radius: 8px;
 -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
 background-color: #bcbaba;
}


.contact-card {
  height: 330px !important;
  border-radius: 10px;
}

.contactList {
  margin-bottom: 0;
  margin-top: 0;
  width: 100%;
}
</style>
